import { render, staticRenderFns } from "./ownerDetailAccessControl.vue?vue&type=template&id=a149274e"
import script from "./ownerDetailAccessControl.vue?vue&type=script&lang=js"
export * from "./ownerDetailAccessControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports